import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';

@Injectable({
  providedIn: 'root'
})
export class ContactparamService {

  constructor() { }

  private defaultConatctString : string = '';

  private _contactString = new BehaviorSubject<string>(this.defaultConatctString);

  public readonly contactString$ = this._contactString.asObservable();

  get contactString() {
    return this._contactString.getValue();
  }

  set contactSting(value: string) {
    this._contactString.next(value);
  }

  addNewContactString(value: string) {
    this.contactSting = value;
  } 

  removeContactString() {
    this.contactSting = this.defaultConatctString;
  }
}
